import React, { Component } from "react";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    IconButton,
} from "@material-ui/core";
import { Clear as ClearIcon } from "@material-ui/icons";
import { StyledContent } from "../../../styles";
export default class Filters extends Component {
    render() {
        const {
            areas,
            departments,
            setArea,
            setAreaType,
            setDepartment,
            setDepartmentType,
            setUserFilter,
            userFilter,
        } = this.props;

        return (
            <StyledContent>
                <div>
                    <div
                        style={{
                            marginLeft: "100px",
                            width: "100%",
                            float: "right",
                        }}
                    >
                        <FormControl style={{ minWidth: 200, marginLeft: 20 }}>
                            <InputLabel>Filter By Areas</InputLabel>
                            <Select
                                value={setArea}
                                onChange={(event) =>
                                    setAreaType(event.target.value)
                                }
                            >
                                <MenuItem value="all_areas">All Areas</MenuItem>
                                {areas &&
                                    Object.values(areas).map((e) => {
                                        return (
                                            <MenuItem value={e}>{e}</MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>

                        <FormControl style={{ minWidth: 200, marginLeft: 20 }}>
                            <InputLabel>Filter By Departments</InputLabel>
                            <Select
                                value={setDepartment}
                                onChange={(event) =>
                                    setDepartmentType(event.target.value)
                                }
                            >
                                <MenuItem value="all_departments">
                                    All Departments
                                </MenuItem>
                                {departments &&
                                    Object.values(departments).map((e) => {
                                        return (
                                            <MenuItem value={e}>{e}</MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                        <FormControl
                            style={{
                                marginLeft: 20,
                                minWidth: 200,
                                display: "initial",
                            }}
                        >
                            <TextField
                                label="Search Users"
                                value={userFilter === false ? "" : userFilter}
                                onChange={(event) => {
                                    setUserFilter(event.target.value);
                                }}
                            />
                            <IconButton>
                                <ClearIcon
                                    style={{ color: "red" }}
                                    onClick={() => setUserFilter(false)}
                                />
                            </IconButton>
                        </FormControl>
                    </div>
                </div>
            </StyledContent>
        );
    }
}
